import type { EmailSearchResult, ProcessedEmailInfo } from '@/types/emailSearch'

export function resolveForwardEmailScope(
  results: EmailSearchResult[],
  selectedIds: Set<string>,
  clickedRow: EmailSearchResult,
): EmailSearchResult[] {
  if (selectedIds.size === 0) {
    return [clickedRow]
  }

  const scope = results.filter((r) => selectedIds.has(r.message_id))
  if (!scope.some((r) => r.message_id === clickedRow.message_id)) {
    scope.push(clickedRow)
  }
  return scope
}

export function shouldIncludePreviouslyReviewed(forwardNewOnly: boolean): boolean {
  return !forwardNewOnly
}

export function emailsToForwardFromDialog(
  scope: EmailSearchResult[],
  processedInfo: Record<string, ProcessedEmailInfo>,
  forwardNewOnly: boolean,
): EmailSearchResult[] {
  if (forwardNewOnly) {
    return scope.filter((r) => !processedInfo[r.message_id])
  }
  return scope
}
